'use strict';
import {LOADED, NO_DATA, PLACEHOLDER} from './loading-states';

/**
 * This callback is displayed as part of the Requester class.
 * @callback ListHasData<T>
 * @param {T} list
 * @return {Boolean} whether the input has data
 */

/**
 *
 * @param {Observable<Array>} list$
 * @param $scope
 * @param vm
 * @param {Boolean} [usePlaceholder=false]
 */
export function updateLoadingMode(list$, $scope, vm, usePlaceholder) {
  return updateLoadingModeGeneric((list) => list.length > 0, list$, $scope, vm, usePlaceholder);
}

/**
 *
 * @param {Observable<FirebaseObject>} list$
 * @param $scope
 * @param vm
 * @param {Boolean} [usePlaceholder=false]
 */
export function updateLoadingModeSize(list$, $scope, vm, usePlaceholder) {
  return updateLoadingModeGeneric((list) => list && list.$size() > 0, list$, $scope, vm, usePlaceholder);
}

/**
 *
 * @param {ListHasData<T>} hasData
 * @param {Observable<T>} list$
 * @param $scope
 * @param vm
 * @param {Boolean} [usePlaceholder=false]
 */
export function updateLoadingModeGeneric(hasData, list$, $scope, vm, usePlaceholder) {
  const noData = usePlaceholder ? PLACEHOLDER : NO_DATA;
  return list$
    .subscribe((list) => {
      $scope.$evalAsync(() => {
        vm.loadingMode = hasData(list) ? LOADED : noData;
      });
    });
}



// WEBPACK FOOTER //
// ./src/js/core-components/loading-icon/utils.js